import axios from 'axios';
import config from '../config.json'
import { celebrateActiveDays, welcomeBackAfterAbsence } from '../utils/alerts';

class Api {
  constructor() {
    this.api = axios.create({
      baseUrl: config.apiUrl
    });
  }

  async query(url, method, body = {}, options = { auth: true }) {
    try {
      const response = await this.api({
        url: config.apiUrl + url,
        method,
        data: body,
        headers: {
          Authorization: this.getToken()
        },
        ...options
      });
      return response.data
    }
    catch (error) {
      return {
        success: false,
        data: error
      };
    }
  }

  async get(url, options = {}) {
    return await this.query(url, "GET", {}, options);
  }

  async post(url, body = {}, options = {}) {
    return await this.query(url, "POST", body, options);
  }

  async put(url, body = {}, options = {}) {
    return await this.query(url, "PUT", body, options);
  }

  async delete(url, options = {}) {
    return await this.query(url, "DELETE", {}, options);
  }

  async updateUserData() {
    // Throttle: bu funksiya mashq tugagach (completion) bir marta chaqiriladi,
    // lekin React StrictMode dev'da effekt'ni ikki marta ishga tushirishi mumkin —
    // shu qisqa oyna takror /user so'rovini oldini oladi (alohida mashqlar
    // tugashiga xalaqit bermaydi).
    const REFRESH_THROTTLE_MS = 3000;
    const now = Date.now();
    if (this._lastUserRefresh && now - this._lastUserRefresh < REFRESH_THROTTLE_MS) {
      return;
    }
    this._lastUserRefresh = now;

    // setUser() yangi qiymatlar bilan localStorage'ni yangilashidan oldin
    // eski holatni saqlab olamiz — alertlarni shu asosda hal qilamiz.
    const previousActiveDays = parseInt(this.getUserActiveDays(), 10) || 0;
    const previousVisit = parseInt(localStorage.getItem(config.check_auth), 10) || 0;

    const { success, data } = await this.get('/user');
    if (success){
      this.setUser(data);

      const currentActiveDays = parseInt(data.user_active_days, 10) || 0;

      // 1) Uzoq tanaffusdan keyin qaytgan foydalanuvchini kutib olamiz.
      const daysAway = previousVisit
        ? Math.floor((Date.now() - previousVisit) / (1000 * 60 * 60 * 24))
        : 0;
      if (daysAway >= 2) {
        welcomeBackAfterAbsence(daysAway, currentActiveDays);
      }
      // 2) Faol kunlar ortgan bo'lsa — tabriklaymiz.
      else if (currentActiveDays > previousActiveDays) {
        celebrateActiveDays(currentActiveDays);
      }
    }
  }

  async updateProfile(data) {
    return await this.query('/user', "PUT", data,{
      headers: {
        Authorization: this.getToken()
      }
    });
  }

  async uploadAvatar(formData) {
    return await this.query('/user/avatar', "POST", formData, {
      headers: {
        Authorization: this.getToken(),
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  async auth() {
    return await this.query('/auth', "GET", {}, {
      auth: true
    });
  }



  setUser(user) {
    localStorage.setItem(config.user_id, user.user_id);
    localStorage.setItem(config.authKey, user.user_token);
    localStorage.setItem(config.user_phone, user.user_phone_number);
    localStorage.setItem(config.user_full_name, user.user_full_name);
    if(user.user_avatar) localStorage.setItem(config.user_avatar, user.user_avatar);
    localStorage.setItem(config.user_type, user.user_type);
    localStorage.setItem(config.user_active_days, user.user_active_days);
    localStorage.setItem(config.check_auth, Date.now());
    // Reaktivlik: localStorage o'zgarishi shu oynada 'storage' eventini
    // ishga tushirmaydi, shuning uchun ma'lumot yangilanganini komponentlarga
    // (masalan navbar'dagi ActiveDays) bildirish uchun custom event tarqatamiz.
    window.dispatchEvent(new CustomEvent('user-data-updated', {
      detail: { activeDays: user.user_active_days }
    }));
    return;
  }

  getToken() {
    return localStorage.getItem(config.authKey);
  }

  getUser() {
    return localStorage.getItem(config.user);
  }
  getUserId() {
    return localStorage.getItem(config.user_id);
  }
  getUserType() {
    return localStorage.getItem(config.user_type);
  }
  getUserPhone() {
    return localStorage.getItem(config.user_phone);
  }
  getUserFullName() {
    return localStorage.getItem(config.user_full_name);
  }
  getUserAvatar() {
    return "https://files.eagles.uz/"+localStorage.getItem(config.user_avatar);
  }
  getUserActiveDays() {
    return localStorage.getItem(config.user_active_days);
  }

  checkIsPremuim(){
    return  axios.get(config.apiUrl + '/user-active-plans', {
      headers: {
        'Authorization': this.getToken()
      }
    }).then((response) => {
      if (response.data.success) {
        if (response.data.data.length === 0) {
          return false;
        }else{
          return true;
        }
      }
    }).catch((error) => {
      if (error.response != undefined) {
        if (error.response.status == 401) {
          api.logOut();
        } else {
          return false;
        }
      }
    });
  }
  logOut() {
    localStorage.clear();
    window.location.href = '/login';
    return;
  }

  chekAuth(){
    if (localStorage.getItem(config.check_auth) != null){
     return true;
    }
    return false;
  }
  async isAdmin() {
    let { success, data } = await this.auth();
    if (success) {
      return data?.data?.isAdmin;
    } else {
      return false;
    }
  }
};

export default new Api();